import { render, staticRenderFns } from "./callback.vue?vue&type=template&id=49a770ee&scoped=true"
import script from "./callback.vue?vue&type=script&lang=ts"
export * from "./callback.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a770ee",
  null
  
)

export default component.exports